const COOKIE_CONSENT_KEY = "cookieConsent";

export function hasCookieConsent(currentVersion) {
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!raw) return false;
    const data = JSON.parse(raw);
    return data?.accepted === true && data?.version === currentVersion;
  } catch {
    return false;
  }
}

export function saveCookieConsent(version) {
  localStorage.setItem(
    COOKIE_CONSENT_KEY,
    JSON.stringify({
      accepted: true,
      version,
      acceptedAt: new Date().toISOString(),
    }),
  );
}
